import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@agentsaas/ui/tokens.css";
import "@agentsaas/ui/components.css";
import "./styles/app.css";
import "./styles/collab.css";
import "./styles/p3p4.css";
import "./styles/p5p6.css";
import "./styles/cap.css";
import "./styles/p8.css";
import { readConfig } from "./app/config";
import { createI18n } from "./app/i18n";
import { createServices } from "./app/services";
import { initTheme } from "./app/theme";
import { ME_KEY } from "./app/session";
import { Root } from "./app/Root";
import { App } from "./app/App";
import { registerServiceWorker } from "./pwa/register";

async function main() {
  initTheme();
  registerServiceWorker();
  const i18n = createI18n();
  const services = await createServices(readConfig(), {
    getLocale: () => i18n.language,
    onUnauthenticated: () => services.queryClient.setQueryData(ME_KEY, null),
  });
  // mock 模式下暴露给 E2E / 调试（例如模拟外部修改文件）
  if (services.mock) (window as unknown as { __mock: unknown }).__mock = services.mock;
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Root services={services} i18n={i18n}>
        <App />
      </Root>
    </StrictMode>,
  );
}

void main();
